import {iSessionStorage} from '@ab/components';

export default function(source) {
    if (!source) return {};

    let json,
        stored,
        data = {};

    if (typeof source === 'string') {
        try {
            json = JSON.parse(decodeURIComponent(source));
        } catch (e) {
            json = {};
        }
    } else if (typeof source === 'object') {
        json = source;
    }

    if (json && typeof json === 'object') {
        if (json.storeId) {
            stored = JSON.parse(iSessionStorage.get(json.storeId));
            stored && (data = stored);
        } else {
            data = json;
        }
    }

    return data;
}
